class AvailabilityReleaseStrategy {
    constructor(base = {}) {
        if (base && base.inOrderRelease) {
            this.inOrderRelease = Object.assign(new InOrderRelease(), base.inOrderRelease);
            this.timeBoundRelease = Object.assign(new TimeBoundRelease(), base.timeBoundRelease);
        } else {
            this.setInitial();
        }
    }

    static createNew() {
        return new AvailabilityReleaseStrategy();
    }

    static createFromEvent(daysBefore, inOrderNumber, inOrderGroup) {
        let availabilityReleaseStrategy = new AvailabilityReleaseStrategy();
        availabilityReleaseStrategy.timeBoundRelease = TimeBoundRelease.createFromEvent(daysBefore);
        availabilityReleaseStrategy.inOrderRelease = InOrderRelease.createFromEvent(inOrderNumber, inOrderGroup);
        return availabilityReleaseStrategy;
    }

    hasReleaseStrategy() {
        return this.inOrderRelease.isDefined || !this.timeBoundRelease.isImmediate;
    }

    reset() {
        this.setInitial();
    }


    setInitial() {
        this.timeBoundRelease = TimeBoundRelease.createImmediate();
        this.inOrderRelease = InOrderRelease.createNotDefined();
    }
}

class InOrderRelease {
    constructor(isDefined, number, group) {
        this.isDefined = isDefined;
        this.number = number;
        this.group = group;
    }

    static createNotDefined() {
        return new InOrderRelease(false, undefined, '#ccc');
    }

    static create(number, group) {
        return new InOrderRelease(true, number, group);
    }

    getReleaseInOrderNumber() {
        if (this.isDefined) {
            return this.number;
        } else {
            return undefined;
        }
    }

    getReleaseInOrderGroup() {
        if (this.isDefined) {
            return this.group;
        } else {
            return undefined;
        }
    }

    static createFromEvent(inOrderNumber, inOrderGroup) {
        if(inOrderGroup && inOrderGroup){
            return new InOrderRelease(true, inOrderNumber, inOrderGroup)
        }

        return new InOrderRelease(false, undefined, undefined);
    }
}

class TimeBoundRelease {
    constructor(immediate, daysBefore) {
        this.isImmediate = immediate;
        this.daysBefore = daysBefore;
    }

    static create(daysBefore) {
        return new TimeBoundRelease(false, daysBefore);
    }

    static createImmediate() {
        return new TimeBoundRelease(true, undefined);
    }

    isDaySelf() {
        return !this.isImmediate && this.daysBefore === 0;
    }

    isXDays() {
        return !this.isImmediate && this.daysBefore > 0;
    }

    getReleaseNumberOfDaysBefore() {
        if (this.isImmediate) {
            return undefined;
        } else {
            return this.daysBefore;
        }
    }

    static createFromEvent(daysBefore) {
        if (daysBefore || daysBefore === 0) {
            return new TimeBoundRelease(false, daysBefore);
        } else {
            return new TimeBoundRelease(true, undefined);
        }
    }
}
